import $ from 'jquery';

var OrderModal = (function () {
  var $paymentContent = $('.js__payment-content');
  var $paymentMethod = $('.js__payment-method');
  var $fillCodentifies = $('.js__fill_codentifies');
  var $modalBtn = $('.js__modal_btn');
  var $modalContent = $('.js__content');
  var $path = $paymentMethod.data('path');
  var $pathCodentifies = $fillCodentifies.data('path');
  var $submitFillCodentifiesPath;
  var $fillPaymentPath;
  var loading = false;
  var $body = $('body');

  var init = function () {
    $('.js__user-device-display').hide();

    $modalBtn.on('click', function (e) {
      openModal(e, $(this).data('path'));
    });

    $fillCodentifies.on('click', function (e) {
      paymentMethod(e);
    });

    $fillCodentifies.on('submit', function (e) {
      paymentMethod(e);
    });

    $body.on('click', '.js__close-btn', function (e) {
      e.preventDefault();
      $paymentContent.html('');
      $('.ui.small.modal.js__payment-modal').modal('hide');
      $('.ui.small.modal.js__modal').modal('hide');
      $('.ui.small.modal.js__fill-sop-modal').modal('hide');
    });

    $body.on('submit', '.js__close-btn', function (e) {
      e.preventDefault();
      $paymentContent.html('');
      $('.ui.small.modal.js__payment-modal').modal('hide');
      $('.ui.small.modal.js__modal').modal('hide');
    });

    $paymentMethod.on('click', function (e) {
      e.preventDefault();
      orderMethod(e);
    });

    $paymentMethod.on('submit', function (e) {
      orderMethod(e);
    });

    $body.on('click', '.js__submit-fill-codentifies', function () {
      makeCall($submitFillCodentifiesPath, $('.form-fill-codentifies'));
    });
    $body.on('click', '.js__fill-payment', function () {
      makeCall($fillPaymentPath, $('.js__payment-method'));
    });

    $body.on('submit', '.js__submit-fill-codentifies', function () {
      makeCall($submitFillCodentifiesPath, $('.form-fill-codentifies'));
    });

    $body.on('submit', '.js__fill-payment', function () {
      makeCall($fillPaymentPath, $('.js__payment-method'));
    });
  };

  var searchCodentifiesInit = function (input) {
    var productVariantId = input.data('productvariantid');
    var path = input.data('path');
    var codentifies = [];
    codentifies.push(input.val());

    if (input.find('.js__input-codentify').val() != '') {
      input.find('input').not('.js__input-codentify').val(input.find('.js__input-codentify').val());
    }

    input.search({
      minCharacters: 3,
      type: 'standard',
      onSelect: function (data) {
        var selectedCodentifie = data.description;
        var selectedCodentifieName = data.name;
        input.find('.js__input-codentify').val(selectedCodentifie);
        input.find('.js__input-codentify').attr('data-name', selectedCodentifieName);
      },
      apiSettings: {
        url: path,
        method: 'GET',
        data: {
          productVariantId: productVariantId,
          codentifies: codentifies.join(','),
        },
        beforeSend: function (settings) {
          settings.data.codentify = input.find('input').val();
          return settings;
        },
        onResponse: function (results) {
          var response = {
            results: [],
          };
          $.each(results, function (index, item) {
            response.results.push({
              title: item.name,
              description: item.value,
            });
          });
          return response;
        },
      },
    });
  };

  var paymentMethod = function (e) {
    e.preventDefault();
    loading = true;

    if (loading) {
      $paymentContent.addClass('loading');

      $('.ui.small.modal.js__payment-modal')
        .modal({
          autofocus: false,
          closable: false,
          observeChanges: false,
          dimmerSettings: {
            className: {
              pageDimmer: 'payment-modal-scroll',
            },
          },
          onShow: function () {
            $paymentContent.load($pathCodentifies, function (response, status, xhr) {
              if ('403' === xhr.status.toString()) {
                window.location.replace($('.js__redirect-holder').data('redirect'));
              }
              $('.ui.small.modal.js__payment-modal').modal('refresh');
              loading = false;
              $paymentContent.removeClass('loading');
              $submitFillCodentifiesPath = $('.js__submit-fill-codentifies').data('path');

              $('.js__user-device-display').show();

              $('.js__init-search-ajax').each(function () {
                $(this).ajaxInput();
              });

              $('.js__codentifiy-autocomplete').each(function () {
                searchCodentifiesInit($(this));
              });
            });
          },
        })
        .modal('show');
    }
  };

  var orderMethod = function () {
    loading = true;
    $paymentContent.addClass('loading');

    if (loading) {
      $('.ui.small.modal.js__payment-modal')
        .modal({
          autofocus: false,
          closable: false,
          observeChanges: true,
          onShow: function () {
            $paymentContent.load($path, function (response, status, xhr) {
              if ('403' === xhr.status.toString()) {
                window.location.replace($('.js__redirect-holder').data('redirect'));
              }
              loading = false;
              $paymentContent.removeClass('loading');
              $fillPaymentPath = $('.js__fill-payment').data('path');
              $('#app_order_fill_payment_method_type_paymentMethod').dropdown();
            });
          },
        })
        .modal('show');
    }
  };

  var makeCall = function (url, data) {
    loading = true;
    if (loading) {
      $.ajax({
        type: 'put',
        url: url,
        data: data.serialize(),
        contentType: 'application/x-www-form-urlencoded',
        beforeSend: function () {
          $('.js__bind-loader').addClass('loading');
        },
        success: function (data) {
          $paymentContent.html(data);
          $('.js__codentifiy-autocomplete').each(function () {
            searchCodentifiesInit($(this));
          });
          $('.js__bind-loader').removeClass('loading');
          loading = false;
        },
        complete: function (xhr) {
          if (xhr.status === 302) {
            window.location.href = xhr.responseJSON.redirect;
          }
          loading = false;
        },
      });
    }
  };

  var openModal = function (e, url) {
    e.preventDefault();

    loading = true;

    if (loading) {
      $modalContent.addClass('loading');

      $('.ui.small.modal.js__modal')
        .modal({
          autofocus: false,
          closable: false,
          observeChanges: true,
          onShow: function () {
            $modalContent.load(url, function (response, status, xhr) {
              if ('403' === xhr.status.toString()) {
                window.location.replace($('.js__redirect-holder').data('redirect'));
              }
              loading = false;
              $modalContent.removeClass('loading');
              $submitFillCodentifiesPath = url;
              $('.js__tooltip').popup();
            });
          },
        })
        .modal('show');
    }
  };

  return {
    init: init,
  };
})();

export default OrderModal;
